import CustomEditableText from './CustomEditableText.jsx';

export { CustomEditableText }



// WEBPACK FOOTER //
// ./components/UI/index.js